<template>
  <div class="component">
    <van-popup v-model="show" round  position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker
          v-model="currentDate"
          type="date"
          :title="showTime"
          :min-minute="minute"
          :min-hour="hour"
          @cancel="show = false"
          @confirm="choseDate"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      currentDate: '',
      date: new Date(),
      index: "",
      // showtime
      showTime: '自定义添加时间',
      minute: null,
      hour: null,
      begin: '',
      i: 0
    }
  },
  watch: {},
  methods: {
    $show(i,e){
      this.show = true
      this.index = i
      this.name = e
      this.minute = null
      this.hour = null
      this.showTime='自定义开始时间'
    },
    choseDate(e) {
      if (this.i === 0) {
        this.i++
        this.begin = e
        this.showTime = "自定义结束时间"
      } else {
        const dateTime =  {
          time: this.formatDate(this.begin) + "|" + this.formatDate(e),
          index:this.index,
          name: this.name
        }
        this.show = false
        this.$emit('change',dateTime)
      }
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.van-action-sheet__header{
  font-weight: bolder;
}
.component {
}
</style>
